<template>
  <v-card class="mb-5">
    <v-toolbar color="primary" dark flat>
      <v-icon class="mr-2">{{icon}}</v-icon>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="actions"></slot>
    </v-toolbar>
    <v-card-text v-if="loading">
      <custom-progress>Cargando detalles</custom-progress>
    </v-card-text>
    <v-list v-else class="py-0">
      <template v-for="(item, index) in items">
        <v-list-item :key="item.label" @click="copyToClipboard(item.value)" dense>
          <v-row align="start">
            <v-col cols="4">
              <v-list-item-content><b>{{ item.label }}</b></v-list-item-content>
            </v-col>
            <v-col cols="8">
              <v-list-item-content>{{ item.value }}</v-list-item-content>
            </v-col>
          </v-row>
        </v-list-item>
        <v-divider
          v-if="index + 1 < items.length"
          :key="index"
        ></v-divider>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import CustomProgress from './CustomProgress'

export default {
  name: 'detail-view',

  components: {
    CustomProgress
  },

  props: {
    items: Array,
    title: {
      default: 'Detalles'
    },
    icon: {
      default: 'mdi-eye'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    copyToClipboard (text) {
      // Create a dummy input to copy the string array inside it
      var dummy = document.createElement('input')

      // Add it to the document
      document.body.appendChild(dummy)

      // Set its ID
      dummy.setAttribute('id', 'dummy_id')

      // Output the array into it
      document.getElementById('dummy_id').value = text

      // Select it
      dummy.select()

      // Copy its contents
      document.execCommand('copy')

      // Remove it as its not needed anymore
      document.body.removeChild(dummy)

      window.app.$toast.success('El contenido fue copiado al portapapeles.')
    }
  }

}
</script>

<style scoped>

</style>
